import { render, staticRenderFns } from "./com-config-items.vue?vue&type=template&id=71923821&scoped=true"
import script from "./com-config-items.vue?vue&type=script&lang=js"
export * from "./com-config-items.vue?vue&type=script&lang=js"
import style0 from "./com-config-items.vue?vue&type=style&index=0&id=71923821&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71923821",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71923821')) {
      api.createRecord('71923821', component.options)
    } else {
      api.reload('71923821', component.options)
    }
    module.hot.accept("./com-config-items.vue?vue&type=template&id=71923821&scoped=true", function () {
      api.rerender('71923821', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/common/com-config-items.vue"
export default component.exports